import React, {useState} from 'react';
import ScoreDots from './ScoreDots';

function Test() {
    const [score, setScore] = useState(0);

    return (
        <div style={{paddingLeft: '20px', userSelect: 'none'}}>
            <div style={{marginBottom: '10px'}}>
                <div style={{textAlign:"left"}}>Пара 1</div>
                <div style={{marginBottom: '5px'}}>
                    <ScoreDots onSelect={setScore} max={5} name={"BL"} disable={false}/>
                    <ScoreDots onSelect={setScore} max={5} name={"BF"}/>
                </div>
                <div style={{marginBottom: '5px'}}>
                    <ScoreDots onSelect={setScore} max={5} name={"LF"}/>
                    <div style={{display: 'flex'}}><ScoreDots onSelect={setScore} max={4} name={"DP"}/><ScoreDots
                        onSelect={setScore} max={1} name={""} bonus /></div>
                </div>
                <div style={{marginBottom: '5px'}}>
                    <ScoreDots onSelect={setScore} max={5} name={"EX"}/>
                    <div style={{display: 'flex'}}><ScoreDots onSelect={setScore} max={4} name={"DV"}/><ScoreDots
                        onSelect={setScore} max={1} name={""} bonus /></div>
                </div>
                <ScoreDots onSelect={setScore} max={5} name={"IN"}/>
                <div style={{display: 'flex'}}><ScoreDots onSelect={setScore} max={4} name={"SP"}/><ScoreDots
                    onSelect={setScore} max={1} name={""} bonus /></div>
            </div>
            <div>
                <div style={{textAlign: "left"}}>Пара 2</div>
                <div style={{marginBottom: '5px'}}>
                    <ScoreDots onSelect={setScore} max={5} name={"BL"} disable={false}/>
                    <ScoreDots onSelect={setScore} max={5} name={"BF"}/>
                </div>
                <div style={{marginBottom: '5px'}}>
                    <ScoreDots onSelect={setScore} max={5} name={"LF"}/>
                    <div style={{display: 'flex'}}><ScoreDots onSelect={setScore} max={4} name={"DP"}/><ScoreDots
                        onSelect={setScore} max={1} name={""} bonus /></div>
                </div>
                <div style={{marginBottom: '5px'}}>
                    <ScoreDots onSelect={setScore} max={5} name={"EX"}/>
                    <div style={{display: 'flex'}}><ScoreDots onSelect={setScore} max={4} name={"DV"}/><ScoreDots
                        onSelect={setScore} max={1} name={""} bonus /></div>
                </div>
                <ScoreDots onSelect={setScore} max={5} name={"IN"}/>
                <div style={{display: 'flex'}}><ScoreDots onSelect={setScore} max={4} name={"SP"}/><ScoreDots
                    onSelect={setScore} max={1} name={""} bonus /></div>
            </div>
        </div>
    );
}

export default Test;